import React, { Component } from "react";

export default class IotImg extends Component {
  render() {
    return <img alt="" src="iot.png"></img>;
  }
}
